export default __webpack_public_path__ + "static/media/ic_uzbekistán.5cc91248.svg";